<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Debtors</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12" class="mt-1" v-if="hideTotals != 'Y'">Total Debt: {{ totalDebt | currency}}</v-col>

          <v-col cols="12" sm="12" md="12">
            <v-btn icon>
              <download-excel :data="debtors" :fields="fields" name="Debtors">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>
            </v-btn>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table v-if="userLoaded" dense :items-per-page="pageItems" :headers="AmayaVersion == true ? amayaHeaders : headers" :items="debtors" :search="search"
              :mobile-breakpoint="zeroValue" :loading="loading" loading-text="Loading debtors...">
              <template v-slot:item.Balance="{ item }">
                <span style="font-weight: bold" v-if="hideTotals != 'Y'">{{
                  item.Balance | currency
                }}</span>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="primary" small @click="openDialog(item)">
                  <v-icon left>mdi-plus</v-icon>Receive Payment
                </v-btn>
              </template>
              <!-- end -->

              <!-- details template -->
              <template v-slot:item.details="{ item }" v-if="userId != 248">
                <v-btn v-if="item.Balance > 0" color="accent" text :to="`/debtors/${item.id}`">
                  Unpaid Invoices <v-icon right>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end of details -->

              <template v-slot:item.statement="{ item }">
                <v-btn color="primary" text :to="`/customer-statement/${item.id}`">
                  Customer Statement
                </v-btn>
              </template>

              <!-- details template -->
              <template v-slot:item.message="{ item }" v-if="userId != 248">
                <v-btn color="green" icon @click="messageModal(item)">
                  <v-icon>mdi-message-processing</v-icon>
                </v-btn>
              </template>
              <!-- end of details -->

            </v-data-table>
            <!-- end -->
          </v-col>

        
        </v-row>

        <!-- message dialog -->
        <v-dialog v-model="messageDialog" max-width="700px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Debt Reminder</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="messageDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="subtitle-2 text--primary">
                  <v-col cols="12">
                    <h4>
                      Are you sure you want to send the following reminder?
                    </h4>
                  </v-col>
                  <v-col cols="12" v-if="debtItem">Customer: {{ debtItem.Name }}</v-col>
                  <v-col cols="12" v-if="debtItem.Balance">Current Debt:
                    {{ debtItem.Balance }}</v-col>

                  <v-col cols="12">
                    <v-textarea v-model="message" outlined label="Custom Message"></v-textarea>
                  </v-col>

                  <v-col cols="6">
                    <v-btn color="accent" @click="sendMessage" :loading="loader">
                      <v-icon left>mdi-arrow-right-circle</v-icon>Yes
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-card>
        </v-dialog>


      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
    HideDebtorsTotal: "",
    zeroValue: 0,
    totalDebt: 0,
    search: "",
    enableCreate: true,
    searchingProduct: false,
    accountDialog: false,
    accountItem: {},
    pageItems: 100,
    messageDialog: false,
    message: null,
    debtItem: {},
    accountId: null,
    dialog: false,
    customer: {},
    Balance: null,
    amount: null,
    accounts: [],
    loader: false,
    loading: false,
    AmayaVersion: true,
    userLoaded: false,
    date: new Date().toISOString().substr(0, 10),
    dateReadonly: "",
    todayDate: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Name", value: "Name" },
      { text: "Current Debt", value: "Balance" },
      { text: "Details", value: "details" },
      { text: "Statement", value: "statement" },
      { text: "Message", value: "message" },
    ],
    amayaHeaders: [
      { text: "Name", value: "Name" },
      { text: "Current Debt", value: "Balance" },
      { text: "Statement", value: "statement" },
    ],
    cashierHeaders: [
      { text: "Name", value: "ocrd.Name" },
      { text: "Action", value: "action" },
      { text: "Message", value: "message" },
    ],
    fields: {
      Name: "Name",
      Balance: "Balance",
    },
    debtors: [],
  }),
  computed: {
    hideTotals() {
      return localStorage.getItem("HideDebtorsTotal");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    userRole() {
      return localStorage.getItem("userRole");
    }
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    messageModal(data) {
      this.debtItem = data;
      this.messageDialog = true;
    },
    sendMessage() {
      const url = "/debt-reminder";
      const data = this.debtItem;
      data.message = this.message;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.debtItem = {};
            self.message = null;
            self.loader = false;
            self.messageDialog = false;
            self.$refs.snackbar.show("Message Sent", "green");
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUserDetails() {
      const userId = localStorage.getItem("userId");
      const self = this;
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.HideDebtorsTotal = res.ResponseData.HideDebtorsTotal;
            this.AmayaVersion = res.ResponseData.AmayaVersion == "Y" ? true : false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          this.userLoaded = true;
        })
        .catch((err) => {
          this.userLoaded = true;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDebtors() {
      const self = this;
      self.loading = true;
      this.$store
        .dispatch("get", `/debtors`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.debtors = res.ResponseData.debtors;
            self.totalDebt = res.ResponseData.totalDebt;
            self.getUserDetails();
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.loading = false;
        });
    },
  },
  created() {
    Promise.all([this.getDebtors()]);
  },
};
</script>